import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const LdsNumericSlider = forwardRef(function LdsNumericSlider({
  max = 100,
  maxAriaLabel = 'Maximum value',
  maxLabel = '100',
  min = 0,
  minAriaLabel = 'Minimum value',
  minLabel = '0',
  showMinMax = false,
  showSteps = false,
  step = 1,
  value = 0,
  valueDisplayType = 'never',
  ...rest
}, ref) {
  return (
    <lds-numeric-slider
      max={max}
      maxAriaLabel={maxAriaLabel}
      maxLabel={maxLabel}
      min={min}
      minAriaLabel={minAriaLabel}
      minLabel={minLabel}
      showMinMax={showMinMax || null}
      showSteps={showSteps || null}
      step={step}
      value={value}
      valueDisplayType={valueDisplayType}
      ref={ref}
      {...rest}
    ></lds-numeric-slider>
  );
});

export default LdsNumericSlider;

LdsNumericSlider.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  valueDisplayType: PropTypes.oneOf(['never', 'always', 'temporary']),
};
